export enum InventorySlot {
    Ammo,
    Head,
    Neck,
    Shoulders,
    Shirt,
    Chest,
    Waist,
    Legs,
    Feet,
    Wrist,
    Hands,
    Ring1,
    Ring2,
    Trinket1,
    Trinket2,
    Back,
    MainHand,
    OffHand,
    Ranged,
    Tabard,

    Profession1Tool = 20,
    Profession1Gear1,
    Profession1Gear2,
    Profession2Tool,
    Profession2Gear1,
    Profession2Gear2,
    CookingTool,
    CookingGear1,
    FishingTool,
    FishingGear1,
    FishingGear2,

    Bag1 = 31,
    Bag2,
    Bag3,
    Bag4,
}
